import PropTypes from 'prop-types'
import { forwardRef, memo, useMemo } from 'react'
import useFallbackRef from 'lib/react/hooks/useFallbackRef'
import classNames from 'lib/util/classNames'
import styles from './Wrapper.module.scss'

/**
 * The `Wrapper`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
const Wrapper = forwardRef((props, forwardedRef) => {
  const { Tag, children, className, isActive, ...rest } = props
  const ref = useFallbackRef(forwardedRef)
  const attributes = useMemo(
    () => ({
      className: classNames([
        className,
        styles.container,
        isActive && styles.active
      ])
    }),
    [className, isActive]
  )

  return (
    <Tag ref={ref} {...attributes} {...rest}>
      {children}
    </Tag>
  )
})

// Display name
Wrapper.displayName = 'Wrapper'

/** @type {object} */
Wrapper.propTypes = {
  isActive: PropTypes.bool,
  children: PropTypes.node,
  Tag: PropTypes.elementType,
  className: PropTypes.string
}

/** @type {object} */
Wrapper.defaultProps = {
  isActive: true,
  Tag: 'section',
  className: ''
}

// Memoize
export default memo(Wrapper)
